import {
  Icon,
  IconColor,
} from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import {
  Text,
  TextFontSize,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';

import * as css from './rule.module.scss';

interface RuleComponentProps {
  title: string;
  isValid: boolean;
}

export const RuleComponent = ({
  title,
  isValid,
}: RuleComponentProps): React.JSX.Element => {
  return (
    <Stack
      alignItems="center"
      gap={GapEnum.S}
      className={isValid ? css.validColor : css.invalidColor}>
      <Icon name={isValid ? 'check' : 'x-close'} color={IconColor.Inherit} />
      <Text fontSize={TextFontSize.Medium}>{title}</Text>
    </Stack>
  );
};
